
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.954 15.5c.32 0 .592-.11.814-.332.221-.222.332-.493.332-.814 0-.32-.11-.592-.332-.813a1.106 1.106 0 00-.814-.333c-.32 0-.592.111-.813.333a1.106 1.106 0 00-.333.813c0 .321.111.592.333.814.221.221.492.332.813.332zm-.825-3.53h1.696c0-.503.057-.9.172-1.19.114-.291.439-.688.974-1.192.397-.398.71-.776.94-1.135.229-.359.343-.79.343-1.295 0-.855-.313-1.512-.94-1.97-.626-.459-1.367-.688-2.222-.688-.871 0-1.578.23-2.12.688a3.638 3.638 0 00-1.135 1.65l1.513.595c.076-.275.248-.573.516-.893.267-.321.676-.482 1.226-.482.489 0 .855.134 1.1.401.244.268.366.562.366.883 0 .305-.091.592-.275.86a3.69 3.69 0 01-.687.744c-.672.596-1.085 1.046-1.238 1.352-.153.306-.229.863-.229 1.673zm.87 7.197c-1.267 0-2.459-.24-3.574-.722a9.256 9.256 0 01-2.91-1.96 9.257 9.257 0 01-1.96-2.91A8.926 8.926 0 01.833 10c0-1.268.24-2.46.722-3.575a9.257 9.257 0 011.96-2.91 9.257 9.257 0 012.91-1.96A8.926 8.926 0 0110 .833c1.268 0 2.46.241 3.575.722a9.257 9.257 0 012.91 1.96 9.256 9.256 0 011.96 2.91A8.925 8.925 0 0119.167 10c0 1.268-.241 2.46-.722 3.575a9.256 9.256 0 01-1.96 2.91 9.256 9.256 0 01-2.91 1.96 8.925 8.925 0 01-3.575.722z"}})])
          )
        }
      }
    